export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6207.90144c17.jpg";